import Vue from 'vue'
import Router from 'vue-router'
import menuModule from 'vuex-store/modules/menu'
import lazyLoading from "../store/modules/menu/lazyLoading";

Vue.use(Router)

var router = new Router({
  mode: 'hash',
  linkActiveClass: 'is-active',
  scrollBehavior: () => ({y: 0}),
  routes: createRoutes()
})

export default router

router.afterEach((to, from) => {
  document.title = `${to.meta.label || to.matched[0].meta.label} - SEOMatic`
})

// Menu should have 2 levels.


function createRoutes() {
   return [
    {
      name: 'Home',
      path: '/',
      meta: {
        label: 'Dashboard',
        auth: true,
      },
      component: lazyLoading('dashboard', true)
    },
    {
      name: 'Login',
      path: '/login',
      meta: {
        auth: false,
        label: 'Log In'
      },
      component: lazyLoading('auth/Login', true),
      props: route => ({ redirect: route.query.redirect })
    },
    {
      name: 'RecoverPassword',
      path: '/recover_password',
      meta: {
        auth: false,
        label: 'Recover Password'
      },
      component: lazyLoading('auth/RecoverPassword', true)
    },
    {
      name: 'SignUp',
      path: '/signup/:plan?',
      meta: {
        auth: false,
        label: 'Sign Up',
      },
      component: lazyLoading('auth/SignUp', true),
      props: true
    }, {
      name: 'Register',
      path: '/payment',
      meta: {
        auth: false,
        label: 'Register'
      },
      component: lazyLoading('auth/Register2', true),
      props: true
    }, {
      name: 'ConfirmingRegistration',
      path: '/account/:accountId/confirming_registration',
      component: lazyLoading('auth/PendingForUser', true),
      meta: {
        auth: true,
        label: 'Confirming Registration'
      },
      props: true
    },
    ...generateRoutesFromMenu(menuModule.state.authorizedItems),
    {
      path: '*',
      redirect: '/'
    }
  ]
}


function generateRoutesFromMenu(menu = [], routes = []) {
  for (let i = 0, l = menu.length; i < l; i++) {
    let item = menu[i]
    if (item.path) {
      routes.push(item)
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children.map(c => {
        //current version of vue auth does not set the auth value of the children
        //to be the same as in the parent by default
        //in our project we can assume that we will always want the route children's auth param
        //to be set the same as in the root (unless they've been set different in advance)
        //we are aware of the fact that unset (i e undefined) auth value has its own logic
        //but its not relevant for our project and therefore we ignore that

        c.meta = c.meta || {}

        if(!(c.meta).hasOwnProperty('auth')) {
          c.meta.auth = item.meta.auth
        }

        return c
      }), routes)
    }
  }
  return routes
}
